import "./styles/default.less"

import * as React from "react"
import * as ReactDOM from "react-dom"
import * as flat from "flat"
import * as qs from "query-string"
import * as _ from "lodash"
import * as mockxhr from "mockxhr"

import * as util from "./util"
import Footer from "./components/Footer2"
import Header from "./components/Header4"
import Partners from "./components/Partners2"
import PopularAndLatest from "./components/PopularAndLatest"
import { Label, Button, Box, Item, Icon } from "./components"
import { actions } from "./flux"
import MathJaxRenderer from "./components/MathJaxRenderer";

interface State {
    query: string
    cols: string[]
    subjects: string[]
    showOthers: boolean
    offlineSubjects: string[]
    sort: any[]
    filters: any
    from: number
    size: number
    data: any[]
    searchEnd: boolean
    formatList: string[]
    columnList: string[]
}

class View extends React.Component<{}, State> {
    constructor(props) {
        super(props)
        let queryParams = flat.unflatten(qs.parse(location.search))
        this.state = {
            subjects: [],
            offlineSubjects: [],
            showOthers: false,
            cols: [],

            query: queryParams.query || "",
            // filters: queryParams.filters || {},
            filters: { status: true },
            sort: [
                { onlineTime: "DESC" },
            ],

            from: 0,
            size: 20,
            data: [],
            searchEnd: false,
            formatList: ['homeWeightPaper', 'homeWeightRecruit', 'weightCareer', 'weightPaper', 'weightNews', 'weightRecruit'],
            columnList: ['weight', 'homeWeightPaper'],
        }
        this.dataFormat = this.dataFormat.bind(this)
        this.columnDataFormat = this.columnDataFormat.bind(this)
    }

    componentDidMount() {
        mockxhr.POST("/api/subject/do?from=0&size=10&type=SEARCH", {
            exportFilter: [],
            query: "",
            subjectDao: {subjectName: ""},
            type: "SEARCH",
        }, ({ hits }) => {
            let arr = _.map(_.sortBy(_.filter(_.map(_.filter(hits, i => i.subjectName !== "其他"), j => this.dataFormat(j)), k => k._weightPaper === 0 && k.weightPaper !== 0), o => o.weightPaper), i => i.subjectName)
            let offlineSubjects = _.map(_.sortBy(_.filter(_.map(_.filter(hits, i => i.subjectName !== "其他"), j => this.dataFormat(j)), k => k._weightPaper === 0 && k.weightPaper === 0), o => o.weightPaper), i => i.subjectName)
            this.setState({ subjects: arr, offlineSubjects })
        })
        mockxhr.POST("/api/column/do?from=0&size=10&type=SEARCH", {
            columnDao: {columnName: ""},
            type: "SEARCH"
        }, res => {
            this.setState({
                cols: _.map((_.filter(_.map(res.hits, i => this.columnDataFormat(i)), j => j.type == "WeightPaper" && j._weight == 0 && j.weight != 0)).sort((a, b) => {
                    return a.weight - b.weight
                }), o => o.columnName)
            })
        })
        this.fetch()
    }

    componentDidUpdate() {
        history.replaceState(
            null, null as any,
            location.pathname + "?" + qs.stringify(flat.flatten({
                query: this.state.query,
                filters: Object.keys(this.state.filters).length ? this.state.filters : undefined,
            }))
        )
    }

    fetch() {
        let { filters, sort, query } = this.state
        filters.onlineTime = null
        actions.api.thesis.search({
            from: 0,
            size: this.state.size,
            type: "SEARCH",
            request: {
                filters, sort, query
            }
        }, resp => {
            if (resp.hits) {
                this.setState({
                    data: resp.hits,
                    from: resp.hits.length,
                    searchEnd: resp.hits.length < this.state.size || resp.total === 0,
                })
            }
        })
    }

    append() {
        let { filters, sort, query } = this.state
        filters.onlineTime = this.state.data && this.state.data[this.state.data.length - 1].onlineTime
        actions.api.thesis.search({
            from: this.state.from,
            size: this.state.size,
            type: "SEARCH",
            request: {
                filters, sort, query
            }
        }, resp => {
            if (resp.hits) {
                const newFrom = this.state.from
                const isSearchEnd = resp.hits.length < this.state.size
                this.setState({
                    data: this.state.data.concat(resp.hits),
                    from: newFrom + resp.hits.length,
                    searchEnd: isSearchEnd
                })
            }
        })
    }

    column(col, onClick?) {
        let selected = this.state.filters.columns === col
        if (col === "全部" && !this.state.filters.columns) selected = true
        let style: any = {
            display: "inline-block",
            margin: "0 .625rem 1.25rem",
            borderRadius: 999,
            width: "10rem",
            height: "1.875rem",
            lineHeight: "1.875rem",
            fontSize: ".85rem",
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: selected ? undefined : "#999",
            color: selected ? undefined : "#999",
            verticalAlign: "text-top",
            fontWeight: selected ? 700 : 400,
            padding: "0 .5em",
        }
        return (
            <div className={(selected ? "text-primary border-color-primary" : "") + " clickable text-center ellipsis"}
                style={style} onClick={() => {
                    if (onClick) {
                        onClick()
                    } else {
                        this.state.filters.columns = col
                        this.fetch()
                    }
                }}>
                {col}
            </div>
        )
    }

    subject(item, onClick?) {
        let selected = this.state.filters.subject === item
        if (item === "全部" && !this.state.filters.subject) selected = true
        let style = {
            fontSize: ".85rem",
            margin: "0 1.25rem 1.25rem 1.25rem",
            verticalAlign: "text-top",
            display: "inline-block",
        }
        return (
            <div style={style} className={"nowrap clickable text-" + (selected ? "primary" : "gray")}
                onClick={() => {
                    if (onClick) {
                        onClick()
                    } else {
                        this.state.filters.subject = item
                        this.fetch()
                    }
                }}>
                {
                    item === "更多" ?
                        (this.state.showOthers ?
                            <Icon name="caret up ml05 text-primary"> 更多</Icon> :
                            <Icon name="caret down ml05 text-primary"> 更多</Icon>) :
                        item
                }
            </div>
        )
    }

    thesis(item) {
        let style: any = {
            fontSize: ".85rem",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            width: "100%",
            overflow: "hidden",
        }
        return (
            <Box style={{ height: "12.5rem", marginTop: "2.5rem" }}>
                <div style={{
                    backgroundImage: `url(${item.cover})`, backgroundSize: "cover",
                    backgroundPosition: "center center",
                    height: "100%", width: "18.75rem",
                }} />
                {util.minWidth("2.5rem")}
                <Item flex relative>
                    <Box fit vertical justified>
                        <a className="ellipsis" href={`/theses/${item.id}`} target="_blank"
                            style={{ fontSize: "1.25rem", color: "inherit", fontWeight: 700 }}>
                            <MathJaxRenderer text={item.title} />
                        </a>
                        <div style={style} className="text-gray">
                            论文标题：{item.thesisTitle}
                        </div>
                        <div style={style} className="text-gray">
                            作者：{(item.authors || []).join("，")}
                        </div>
                        <div style={style} className="text-gray">
                            期刊：{item.journals && item.journals.join('; ')}
                        </div>
                        <div style={style} className="text-gray">
                            发表日期：{(item.publishDate || "").replace(/-/g, "/")}
                        </div>
                        <Box center>
                            <Item flex style={{ overflow: "hidden", height: 28 }}>
                                {(item.tags || []).map(tag =>
                                    <Label basic size="tiny" circular className="style2"
                                        style={{ display: "inline-block", marginRight: ".5rem", marginBottom: '0.5rem' }}>
                                        {tag}
                                    </Label>
                                )}
                            </Item>
                            {util.minWidth("2.5rem")}
                            <div style={{ ...style, width: "auto" }} className="text-minor">
                                {util.formatTimestamp(item.onlineTime)}
                            </div>
                        </Box>
                    </Box>
                </Item>
            </Box>
        )
    }

    dataFormat(parm) {
        let obj = {}
        _.forEach(parm, (item, index) => {
            if (_.indexOf(this.state.formatList, index) < 0) {
                obj[index] = item
            } else {
                obj[index] = parseInt(Object.keys(item)[0], 10)
                obj[`_${index}`] = parseInt(item[Object.keys(item)[0]], 10)
            }
        })
        return obj
    }

    columnDataFormat(parm) {
        let obj = {}
        _.forEach(parm, (item, index) => {
            if (_.indexOf(this.state.columnList, index) < 0) {
                obj[index] = item
            } else {
                obj[index] = (item as string).split(";")[0]
                obj[`_${index}`] = (item as string).split(";")[1]
            }
        })
        return obj
    }

    render() {
        return (
            <Box vertical relative style={{ minHeight: "100%" }} className="min-view">
                <Header tab="THESIS" search="theses" style={{maxWidth: '1180px', minWidth: '1180px'}} />

                <Item className="bg-color-1">
                    <Box centerJustified>
                        <div className="fix-view bg-color-white" style={{ padding: "0 3.75rem" }}>
                            {util.minHeight("2.5rem")}
                            <Box centerJustified>
                                <div className="text-center" style={{ maxWidth: "45rem", lineHeight: 0 }}>
                                    {this.column("全部", () => {
                                        delete this.state.filters.columns
                                        this.fetch()
                                    })}
                                    {this.state.cols.slice(0, 11).map(c => this.column(c))}
                                </div>
                            </Box>
                            {util.minHeight("1.25rem")}
                            <Box wrap centerJustified className="line-height">
                                {this.subject("全部", () => {
                                    delete this.state.filters.subject
                                    this.fetch()
                                })}
                                {(this.state.showOthers ? this.state.subjects.concat(this.state.offlineSubjects) : this.state.subjects).map(s => this.subject(s))}
                                {this.subject("其他")}
                                {this.subject("更多", () => {
                                    this.setState({
                                        showOthers: !this.state.showOthers
                                    })
                                })}
                            </Box>
                            {util.minHeight("1.25rem")}
                            <div className="bg-color-2" style={{ height: 1 }} />
                            {util.minHeight("2.5rem")}
                            <PopularAndLatest
                                onClick0={() => {
                                    this.setState({
                                        sort: [
                                            { onlineTime: "DESC" },
                                        ]
                                    }, () => this.fetch())
                                }}
                                onClick1={() => {
                                    this.setState({
                                        sort: [
                                            { popular: "DESC" },
                                            { weight: "DESC" },
                                            { onlineTime: "DESC" },
                                        ]
                                    }, () => this.fetch())
                                }}
                            />
                            {this.state.data.length == 0 && 
                            <Box centerJustified>
                                 <div className="text-center" style={{ marginTop: 110, lineHeight: 1 }}>
                                     <img src={util.iconURL("empty.png")} style={{ height: 80 }} />
                                     {util.minHeight(30)}
                                     <div style={{ fontSize: 16 }}>
                                         暂无相关内容
                                     </div>
                                 </div>
                             </Box>
                            }
                            {this.state.data.length > 0 && this.state.data.map(x => this.thesis(x))}
                            {util.minHeight("2.5rem")}
                            {this.state.data.length ? !this.state.searchEnd && <Button primary fluid onClick={() => this.append()}>
                                加载更多
                            </Button> : null}
                            {util.minHeight("2.5rem")}
                        </div>
                    </Box>
                </Item>

                <Partners />
                <Footer />
            </Box>
        )
    }
}

ReactDOM.render(<View />, document.body.firstChild as any)
